import React, { useState, useEffect } from 'react';
import iconSpain                      from '../../images/icon-spain.svg';
import iconItaly                      from '../../images/icon-italy.svg';
import iconUK                         from '../../images/icon-uk.svg';
import { Close as CloseIcon }         from '@mui/icons-material';
import axios                          from 'axios';
import { useTranslation }             from 'react-i18next';
import CustomTextFieldModifica        from '../../components/fields/CustomTextFieldModifica';
import CustomAutocomplete             from '../../components/fields/CustomAutocomplete';
import CustomNumberModifica           from '../../components/fields/CustomNumberModifica';
import { 
    Dialog, 
    DialogTitle, 
    DialogContent, 
    DialogActions, 
    Button, 
    Box, 
    IconButton,
    Skeleton
}  from '@mui/material';
import ApiService from '../service/ApiService';


const EditUserForm = ({ userData, onClose }) => {
    const { t } = useTranslation();

    const [errors, setErrors] = useState({});
    const [lingua, setLingua] = useState(findLanguageOption(userData.lingua));

    const [formValues, setFormValues] = useState({
        nome:                       userData?.user?.nome                        || '',
        cognome:                    userData?.user?.cognome                     || '',
        telefono:                   userData?.telefono                          || '',
        pIva:                       userData?.pIva                              || '',
        personaContatto:            userData?.personaContatto                   || '',
        emailPersonaContatto:       userData?.emailPersonaContatto              || '',
        commercialeRiferimento:  `${userData?.commerciale?.[0]?.nome || ''} ${userData?.commerciale?.[0]?.cognome || ''}`,
    });
    const findLanguageOption = (value) => {
        if (value) {
            return languageOptions.find(opt => opt.value === value.toLowerCase());
        }
        return null;
    };

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const user = JSON.parse(sessionStorage.getItem("user"));
    const token = user?.token;
    const headers = {
        Authorization: `Bearer ${token}`,
    };

    const languageOptions = [
        { value: 'it', label: t('Italiano'), flag: iconItaly },
        { value: 'es', label: t('Spagnolo'), flag: iconSpain },
        { value: 'en', label: t('Inglese'),  flag: iconUK    },
    ];

    useEffect(() => {
        if ((formValues.username && !emailRegex.test(formValues.username)) || (formValues.emailPersonaDiContatto && !emailRegex.test(formValues.emailPersonaDiContatto))) {
            setFormValues((errors) => ({ ...errors, username: true, emailPersonaDiContatto: true }));
        } else {
            setFormValues((errors) => ({ ...errors, username: false, emailPersonaDiContatto: false }));
        }
    }, [formValues.username, formValues.emailPersonaDiContatto]);

    const handleInputChange = (input) => {
        setFormValues({
            ...formValues,
            ...input,
        });
        setErrors({
            ...errors,
            ...Object.keys(input).reduce((acc, key) => {
                if (input[key] === '') {
                    acc[key] = 'Questo campo è obbligatorio';
                } else {
                    delete errors[key];
                }
                return acc;
            }, {}),
        });
    };


    const handleSelectChange = (fieldValue) => {
        setFormValues((prevValues) => ({
            ...prevValues,
            ...fieldValue,
        }));
    };

    const handleSave = async () => {
        try {
            const updatedUser = {
                nome:                   formValues?.nome,
                cognome:                formValues?.cognome,
                telefono:               formValues?.telefono,
                pIva:                   formValues?.pIva,
                personaContatto:        formValues?.personaContatto,
                emailPersonaContatto:   formValues?.emailPersonaContatto,
                commercialeRiferimento: formValues?.commercialeRiferimento,
            };
    
            // const response = await axios.post("http://localhost:8080/cliente/salva", updatedUser, 
            //     { headers: headers}
            // );
            const response = await ApiService.request("clienteSave", updatedUser);
            if (response.status === 200) {
                onClose(); 
            } else {
                console.error("Errore durante l'aggiornamento:", response.status);
            }
        } catch (error) {
            console.error("Errore durante l'aggiornamento dei dati:", error);
        }
    };




    const fields = [
        { label: t('Nome'),                         name: 'nome',                   type: 'text',   maxLength: 20 },
        { label: t('Cognome'),                      name: 'cognome',                type: 'text',   maxLength: 20 },
        { label: t('Cellulare'),                    name: 'telefono',               type: 'number'                },
        { label: t('Partita iva'),                  name: 'pIva',                   type: 'text',   maxLength: 20 },
        { label: t('Persona di contatto'),          name: 'personaContatto',        type: 'text',   maxLength: 20 },
        { label: t('Email persona di contatto'),    name: 'emailPersonaContatto',   type: 'text',   maxLength: 20 },
        { label: t('Commerciale di riferimento'),   name: 'commercialeRiferimento', type: 'text',   maxLength: 20 },
    ];

    const initialValues = {
        nome:                   userData.nome                   || null,
        cognome:                userData.cognome                || null,
        telefono:               userData.telefono               || null,
        pIva:                   userData.pIva                   || null,
        personaContatto:        userData.personaContatto        || null,
        emailPersonaContatto:   userData.emailPersonaContatto   || null,
        commercialeRiferimento: userData.commercialeRiferimento || null,
    }

    const renderFields = (field) => {
        const { name, label, type, options, ...otherProps } = field;

        switch (type) {
            case 'text':
                return (
                    <CustomTextFieldModifica
                        name={name}
                        label={label}
                        type={type}
                        values={formValues}
                        onChange={handleInputChange}
                        initialValues={initialValues}
                        maxLength={field.maxLength}
                        />
                );

            case 'number':
                return (
                    <CustomNumberModifica
                        key={name}
                        name={name}
                        label={label}
                        values={formValues}
                        onChange={handleInputChange}
                        error={!!errors[name]}
                        helperText={errors[name]}
                        {...otherProps}
                    />
                );
                case 'select': {
                    const initialValue = field.options.find(option => option.value === formValues[name]);
                    return (
                    <CustomAutocomplete
                            // key={field.name}
                            name={name}
                            label={label}
                            options={options}
                            value={formValues[name] || null}
                            onChange={handleSelectChange}
                            initialValue={initialValue}
                        />
                    )
                }
            default:
                return null;
        }
    };

    
    if (!userData) {
        return (
            <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
                <Skeleton variant="text" height={40} />
                <Skeleton variant="text" height={40} />
                <Skeleton variant="text" height={40} />
                <Skeleton variant="text" height={40} />
                <Skeleton variant="rectangular" height={60} sx={{ gridColumn: 'span 2' }} />
            </Box>
        );
    }
    
    return (
        <Dialog open onClose={onClose} maxWidth="md" fullWidth>
            <Box sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                px: 2, 
                py: 1,
                
            }}>
            <DialogTitle>{t('Modifica Profilo Utente')}</DialogTitle>
            <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        color: "#28334B",
                        '&:hover': {
                            color: 'red',
                            transform: 'scale(1.01)',
                            bgcolor: 'transparent'
                        }
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </Box>
            <DialogContent>
                <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, mt: 1 }}>
                    {fields.map((field) => {
                        return renderFields(field);
                    })}
                </Box>
            </DialogContent>

            <DialogActions sx={{ widtht:'100%', justifyContent: 'center', mb: 2, gap: 1}}>
                <Button
                    onClick={onClose}
                    variant="contained"
                    sx={{
                        borderRadius: '10px',
                        width: '10em',
                        backgroundColor: "#b0bec5",
                        color: "#ffffff",
                        "&:hover": {
                            transform: "scale(1.05)",
                            backgroundColor: "#90a4ae",
                        },
                    }}
                >
                    {t('Annulla')}
                </Button>
                <Button
                    onClick={handleSave}
                    color="primary"
                    sx={{
                        borderRadius: '10px',
                        width: '10em',
                        backgroundColor: "#213d72",
                        color: "#ffffff",
                        "&:hover": {
                            backgroundColor: "#1a315b",
                            transform: "scale(1.05)",
                        },
                    }}>{t('Salva')}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default EditUserForm;
